import React from "react";

const HeartIcon = ({
  isMapCard = false,
  onWatchList = "N",
  className = "",
}) => {
  const size = isMapCard ? 20 : 24;
  const outerFill = onWatchList === "Y" ? "#F25D49" : "#00000066";
  const innerFill = onWatchList === "Y" ? "#F25D49" : "white";

  return (
    <svg
      className={`heart-layer-first ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 24"
      fill={outerFill}
    >
      <g id="card/property/heart/empty" opacity="0.8">
        <path
          className="heart-layer-second"
          d="M14 22C14 22 2 16.9734 2 8.32493C2 4.8814 4.86628 2 8.58933 2C11.8045 2 13.8776 5.18815 14 5.33006C14.1234 5.18815 16.1998 2 19.4759 2C23.1989 2 26 4.8814 26 8.32493C26 17.4749 14 22 14 22Z"
          fill={innerFill}
          stroke="#ADC4DA"
          strokeWidth="2.4"
        />
      </g>
    </svg>
  );
};

export default HeartIcon;
